import {
  BUMP_PENDING_DIRECT_THREAD_COUNT,
  CHANGE_THREAD_OWNER,
  GET_DIRECT_CHATS_STARTED,
  GET_DIRECT_CHATS_SUCCESS,
  GET_DIRECT_MESSAGE_FROM_PUSH,
  GET_DIRECT_THREAD_FAILED,
  GET_DIRECT_THREAD_SUCCESS,
  GET_NEW_MESSAGE,
  GET_SERVICE_THREAD_STARTED,
  OPTING_IN_GUEST_TO_CHAT_SUCCESS,
  OPTING_OUT_GUEST_FROM_CHAT_SUCCESS,
  RESOLVE_THREAD_DIRECT_STARTED,
  RESOLVE_THREAD_DIRECT_SUCCESS,
  SEND_DIRECT_MESSAGE_STARTED,
  SEND_DIRECT_MESSAGE_SUCCESS,
  SET_CURRENT_DIRECT_THREAD,
  UPDATE_DIRECT_TYPING_USERS,
  UPDATE_PENDING_THREAD_COUNT,
  UPDATE_SINGLE_DIRECT_TYPING_USER
} from '../actions/actionTypes'

const defaultState = {
  loading: true,
  currentchatId: null,
  threadLoading: false,
  threads: {},
  typingUsers: {},
  pendingThreadsCount: 0
}

export default function serviceMessaging(state = defaultState, action) {
  switch (action.type) {
    case UPDATE_PENDING_THREAD_COUNT:
      return {
        ...state,
        pendingThreadsCount: action.payload.pendingMessageCountForDirect
      }

    case BUMP_PENDING_DIRECT_THREAD_COUNT:
      return {
        ...state,
        pendingThreadsCount: state.pendingThreadsCount + action.payload
      }

    case 'POST_AND_SELECT_SUBSIDIARY_STARTED':
      return {
        ...defaultState
      }

    case GET_DIRECT_CHATS_STARTED:
      return {
        ...state,
        loading: true
      }

    case GET_DIRECT_CHATS_SUCCESS:
      return {
        ...state,
        loading: false,
        threads: {
          ...state.threads,
          ...action.payload.reduce(
            (p, c) => ({
              ...p,
              [c.chatId]: {
                ...(state.threads[c.chatId] ? state.threads[c.chatId] : {}),
                ...c,
                messages: state.threads[c.chatId] ? state.threads[c.chatId].messages : []
              }
            }),
            {}
          )
        }
      }

    case SET_CURRENT_DIRECT_THREAD:
      return {
        ...state,
        currentchatId: action.payload,
        typingUsers: {}
      }

    case GET_SERVICE_THREAD_STARTED:
      return {
        ...state,
        currentchatId: action.payload.chatId,
        threadLoading: true
      }

    case GET_DIRECT_THREAD_FAILED:
      return {
        ...state,
        currentchatId: null,
        threadLoading: false
      }

    case GET_DIRECT_THREAD_SUCCESS:
      return {
        ...state,
        threadLoading: false,
        threadsUpdatedOn: Date.now(),
        threads: {
          ...state.threads,
          [action.payload.chatId]: {
            ...state.threads[action.payload.chatId],
            ...action.payload,
            updatedOn: Date.now()
          }
        }
      }

    case GET_NEW_MESSAGE: {
      const { chatId, message } = action.payload

      return {
        ...state,
        threads: {
          ...state.threads,
          [chatId]: {
            ...state.threads[chatId],
            messages: [...state.threads[chatId].messages, message]
          }
        }
      }
    }

    case GET_DIRECT_MESSAGE_FROM_PUSH: {
      const { subscriberId, message, status } = action.payload
      const { chatMessageId } = message

      // find chat id using subscriber id

      const chatId = Object.keys(state.threads).find(
        chatId => state.threads[chatId].subscriberId === subscriberId
      )

      if (!chatId) {
        return { ...state }
      }

      if (!state.threads[chatId]) {
        return { ...state }
      }

      const newCount = message.isSenderClient
        ? state.threads[chatId].messages
            .slice()
            .reverse()
            .findIndex(m => !m.isSenderClient) + 1
        : 0

      const oldMessage =
        state.threads[chatId].messages.find(o => o.chatMessageId === chatMessageId) || {}

      return {
        ...state,
        threads: {
          ...state.threads,
          [chatId]: {
            ...state.threads[chatId],
            lastMessage: message.content,
            lastMessageOn: message.finalizedOn,
            waitingMessageCount: newCount,
            lastMessageBotIntent: message.botIntent,
            status,
            messages: [
              ...state.threads[chatId].messages.filter(
                o => o.chatMessageId !== chatMessageId
              ),
              { ...oldMessage, ...message }
            ]
          }
        }
      }
    }

    case SEND_DIRECT_MESSAGE_STARTED: {
      const { chatId, message } = action.payload

      return {
        ...state,
        threads: {
          ...state.threads,
          [chatId]: {
            ...state.threads[chatId],
            messages: [...state.threads[chatId].messages, message]
          }
        }
      }
    }

    case SEND_DIRECT_MESSAGE_SUCCESS: {
      const { chatId, message } = action.payload
      const controlKey = message.requestControlKeyEcho

      return {
        ...state,
        threads: {
          ...state.threads,
          [chatId]: {
            ...state.threads[chatId],
            status: 'AgentResponded',
            waitingMessageCount: 0,
            messages: [
              ...state.threads[chatId].messages.filter(o => o.controlKey !== controlKey),
              message
            ]
          }
        }
      }
    }

    case UPDATE_DIRECT_TYPING_USERS: {
      return {
        ...state,
        typingUsers: action.payload
      }
    }

    case UPDATE_SINGLE_DIRECT_TYPING_USER: {
      let typingUsers = Object.values({ ...state.typingUsers })
        .filter(user => user.userId !== action.payload.userId)
        .reduce((prev, current) => {
          return {
            ...prev,
            [current.userId]: { ...current }
          }
        }, {})

      if (action.payload.isTyping) {
        typingUsers[action.payload.userId] = { ...action.payload }
      }

      return {
        ...state,
        typingUsers
      }
    }

    case CHANGE_THREAD_OWNER: {
      if (Object.keys(state.threads).includes(String(action.payload.chatId))) {
        return {
          ...state,
          threads: {
            ...state.threads,
            [action.payload.chatId]: {
              ...state.threads[action.payload.chatId],
              ownedBy: action.payload.currentOwner
            }
          }
        }
      } else {
        return { ...state }
      }
    }

    case OPTING_IN_GUEST_TO_CHAT_SUCCESS: {
      if (Object.keys(state.threads).includes(String(action.payload.chatId))) {
        return {
          ...state,
          threads: {
            ...state.threads,
            [action.payload.chatId]: {
              ...state.threads[action.payload.chatId],
              subscriptionStatus: 'Active'
            }
          }
        }
      } else {
        return { ...state }
      }
    }

    case OPTING_OUT_GUEST_FROM_CHAT_SUCCESS: {
      if (Object.keys(state.threads).includes(String(action.payload.chatId))) {
        return {
          ...state,
          threads: {
            ...state.threads,
            [action.payload.chatId]: {
              ...state.threads[action.payload.chatId],
              subscriptionStatus: 'DoNotCall'
            }
          }
        }
      } else {
        return { ...state }
      }
    }

    case RESOLVE_THREAD_DIRECT_STARTED:
      return {
        ...state,
        currentchatId: null,
        threads: {
          ...state.threads,
          [action.payload.chatId]: {
            ...state.threads[action.payload.chatId],
            isResolving: true
          }
        }
      }

    case RESOLVE_THREAD_DIRECT_SUCCESS:
      return {
        ...state,
        currentchatId: null,
        threads: {
          ...state.threads,
          [action.payload.chatId]: {
            ...state.threads[action.payload.chatId],
            status: 'Closed',
            isResolving: false
          }
        }
      }

    default:
      return state
  }
}
